import React, { useState } from 'react';
import {
  Form,
  Button,
  Col,
  Input,
  Modal,
  Row,
  Spin,
  Typography,
  Divider,
  Select,
  Collapse,
  Upload
} from 'antd';
import { UploadOutlined } from '@ant-design/icons';

import { countryList } from '../../data/countryList';

import '../Common/Form.css';
import { beforeImageUpload } from '../../utilities/imageUpload';
import ImageUploadSection from '../ImageUploadSection';
import { getTrainers } from '../../services/trainerServices';
const { Text } = Typography;
const { TextArea } = Input;
const { Panel } = Collapse;

const { Option } = Select;

const countryListMenu = countryList.map((country) => (
  <Option key={country.id} value={country.id}>
    {country.name}
  </Option>
));

export const renderTrainerForm = (form, onImageUpload) => {
  return (
    <>
      <Form.Item
        label="First Name"
        name="firstName"
        rules={[{ required: true, message: 'Please input first name!' }]}>
        <Input />
      </Form.Item>
      <Form.Item
        label="Last Name"
        name="lastName"
        rules={[{ required: true, message: 'Please input last name!' }]}>
        <Input />
      </Form.Item>
      <Form.Item
        label="Email"
        name="email"
        rules={[{ required: true, message: 'Please input email!' }]}>
        <Input />
      </Form.Item>
      <Form.Item
        label="Description( Max 140 Chars )"
        name="description"
        rules={[
          { required: true, message: 'Please input description!' },
          {
            max: 140,
            message: 'Description should not be more than 140 characters'
          }
        ]}>
        <TextArea rows={4} />
      </Form.Item>
      <Form.Item
        label="Long Description (Max 500 Chars)"
        name="longDescription"
        rules={[
          { required: true, message: 'Please input long description!' },
          {
            max: 500,
            message:
              'Long Description should not be more than 500 characters'
          }
        ]}>
        <TextArea rows={4} />
      </Form.Item>
      <Upload
        beforeUpload={beforeImageUpload}
        customRequest={onImageUpload}>
        <Button icon={<UploadOutlined />}>Click to Upload</Button>
      </Upload>
      <Form.Item
        label="Profile Image"
        name="profileImage"
        rules={[
          { required: true, message: 'Please input profile image!' }
        ]}>
        <Input />
      </Form.Item>
      <div
        style={{
          marginBottom: 20
        }}>
        <Collapse>
          <Panel header="meetFacilitatorImg" key="2" forceRender={true}>
            <section>
              <ImageUploadSection
                beforeImageUpload={beforeImageUpload}
                nest={['meetFacilitatorImg']}
                // Need to insert name of course here `ssr-academy/${courseName}/cohort/png/`
                path={`na-portal/trainerProfile/meetFacilitatorImages/`}
                bucket={'image-assets.nasdaily.com'}
                form={form}
                hideResolution={{ desktop: true, mobile: true }}
                imgRequired={{ mobile: true, desktop: true }}
                showWebP={false}
              />
            </section>
          </Panel>
        </Collapse>
      </div>

      <Form.Item
        label="Country"
        name="countryId"
        rules={[{ required: true, message: 'Please select Country!' }]}>
        <Select placeholder="Select a country">{countryListMenu}</Select>
      </Form.Item>
    </>
  );
};

export const fetchTrainers = async (setTrainers) => {
  await getTrainers(0, 0, { sortBy: 'firstName', sortOrder: 'asc' })
    .then((response) => {
      const trainerList = response.data.paginatedList;
      const data = trainerList.map((trainer) => ({
        label: `${trainer.firstName} ${trainer.lastName}`,
        value: trainer._id
      }));
      setTrainers(data);
    })
    .catch((error) => {
      console.log('Error getting data from the admin backend:', error);
      alert('Getting trainers from the backend failed!');
    });
};

export const renderTrainerPick = (
  trainers,
  trainerRequired,
  elementName
) => {
  return (
    <>
      <Form.Item
        label="trainer"
        name={elementName}
        rules={[
          {
            required: trainerRequired
          }
        ]}>
        <Select
          mode={''}
          placeholder="Search trainer"
          notFoundContent={<Spin size="small" />}
          filterOption={false}
          showSearch={true}
          dropdownRender={(menu) => <div>{menu}</div>}>
          {trainers?.map((item) => (
            <Select.Option value={item.value}>
              <Panel header={item.label} key="1"></Panel>
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
    </>
  );
};
